// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + ({"264":"Registration","961":"Users"}[chunkId] || chunkId) + "." + {"29":"aa559f29","264":"1701142f","961":"d6dc8ab3"}[chunkId] + ".css";
};